module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei7.svg";